import { useState, useEffect } from 'react';
export default (function (element, rootMargin) {
    var _a = useState(false), isVisible = _a[0], setState = _a[1];
    useEffect(function () {
        var copy = element.current;
        var observer = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            setState(entry.isIntersecting);
        }, { rootMargin: rootMargin });
        element.current && observer.observe(element.current);
        return function () {
            if (!copy)
                return;
            observer.unobserve(copy);
        };
    }, [element, rootMargin]);
    return isVisible;
});
